import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import { ZoneReducerType } from "./Types";
import Zone from "../../Models/Zone";

const initialState: ZoneReducerType = {
  zones: [],
  zonesByCity: [],
}

const ZoneSlice = createSlice({
  name: "Zone",
  initialState,
  reducers: {
    getZones(state) {},
    setZones(state: any, { payload }: PayloadAction<Zone[]>) {
      state.zones = payload
    },
    getZonesByCity(state, { payload }: PayloadAction<string>) {},
    setZonesByCity(state, { payload }: PayloadAction<Zone[]>) {
      state.zonesByCity = payload
    },
  }
});

export const ZoneActions = ZoneSlice.actions;

export default ZoneSlice.reducer
